import { motion } from "framer-motion";
import { ScanSearch, BrainCircuit, Zap } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const pillars = [
  {
    n: "01",
    icon: ScanSearch,
    title: "Decodifica",
    tag: "Consapevolezza",
    body: "Identifichiamo gli schemi inconsci che guidano le tue reazioni e li portiamo alla luce. Senza consapevolezza non c'è cambiamento.",
  },
  {
    n: "02",
    icon: BrainCircuit,
    title: "Riprogrammazione",
    tag: "PNL & Focus",
    body: "Con la Programmazione Neuro-Linguistica riscriviamo il dialogo interno e riportiamo il focus dove serve. Nuovi schemi, nuove risposte.",
  },
  {
    n: "03",
    icon: Zap,
    title: "Azione",
    tag: "Risultati misurabili",
    body: "Traduciamo la strategia in micro-step concreti e misurabili. Perché l'azione imperfetta batte sempre la perfezione immobile.",
  },
];

export default function MetodoSintesi() {
  return (
    <section
      id="metodo-sintesi"
      className="relative bg-background py-28 md:py-40 border-t border-white/10"
      data-testid="metodo-sintesi-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 md:mb-24 max-w-3xl">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-primary" />
            <span className="text-[11px] tracking-[0.35em] text-primary">
              IL METODO SINTESI
            </span>
          </div>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight">
            Tre passaggi. Zero fuffa.
          </h2>
          <p className="mt-6 text-muted-foreground max-w-xl leading-relaxed">
            Un sistema che unisce PNL e pragmatica dell'azione per portarti
            dall'analisi infinita alla sintesi d'azione.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {pillars.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="group bg-card p-8 md:p-10 min-h-[360px] flex flex-col justify-between hover:bg-secondary transition-colors duration-500"
              data-testid={`pilastro-${p.n}`}
            >
              <div className="flex items-start justify-between">
                <p.icon className="text-primary" size={30} strokeWidth={1.2} />
                <span className="font-serif text-5xl text-white/5 group-hover:text-primary/30 transition-colors duration-500">
                  {p.n}
                </span>
              </div>
              <div>
                <span className="text-[10px] tracking-[0.3em] text-primary">
                  {p.tag.toUpperCase()}
                </span>
                <h3 className="font-serif text-3xl text-foreground mt-2 mb-3">
                  {p.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {p.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 rounded-2xl border border-white/10 bg-card p-8 md:p-10"
        >
          <p className="font-serif text-2xl md:text-3xl text-foreground max-w-2xl leading-snug">
            Dall'analisi alla sintesi d'azione. In un percorso su misura.
          </p>
          <button
            onClick={() => scrollToId("candidatura")}
            className="shrink-0 inline-flex items-center gap-3 rounded-full bg-primary text-primary-foreground px-8 py-4 text-sm tracking-[0.12em] hover:bg-primary/90 transition-colors duration-300"
            data-testid="metodo-sintesi-cta"
          >
            PRENOTA LA TUA ANALISI →
          </button>
        </motion.div>
      </div>
    </section>
  );
}
